import styled from 'styled-components';
import { TextareaAutosize } from "@mui/material";
import { theme } from "styled-tools";

const TextArea = styled(TextareaAutosize)`
  padding: 0.5rem;
  color: ${theme('colors.darkBlue')};
  font-weight: bold;
  border: solid 1px ${theme('colors.lightGrey')};
  border-radius: 4px;
  width: 100%;
  resize: vertical;
`;

export default TextArea;
